export function useOnClick(props) {
  return async function onClick(e) {
    e.preventDefault()
    window.location.reload()
  }
}
